import React, { useState,useContext, useEffect } from 'react';
import { makeRequest } from "../../../axios";
import { AuthContext } from "../../../authcontext/authContext";


import './userdb.scss';

const Profile = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
  });
  const [formData1, setFormData1] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [selectedUser, setSelectedUser] = useState({})
  const [userInfo, setUserInfo] = useState({})

  const { passupdate1 } = useContext(AuthContext);
//   const [submitted1, setSubmitted1] = useState(false);

  // Handle input changes for each field
  const handleChanges = (e) => {
    const { name, value } = e.target;
    setSelectedUser((prev) => ({ ...prev, [name]: value }));
    
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFormData1({ ...formData1, [name]: value, email:userInfo.info?.email });
  };
  console.log(formData1)

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    setFormData({ name: '', email: '', phone: '', address: '' });

  };

  const handleSubmit1 = async (e) => {
    e.preventDefault();
    console.log(formData1)

    if (formData1.newPassword !== formData1.confirmPassword) {
        setError('Passwords do not match');
        setTimeout(() => setError(''), 2000);
        return;
      }
        try {
          await passupdate1(formData1);
        } catch (err) {
          
        }
    
  };

  useEffect(() => {
    makeRequest.get("user-info/user").then((res) => {
      setUserInfo(res.data)
      setSelectedUser(res.data.info)
      
    } 
    )
   
  }, []);
  console.log(userInfo, "olo")
  console.log(selectedUser,"pol")
  

  return (
    <div className='form1' style={{}}>
    <div style={{}} className={`form1-container ${submitted ? 'submitted' : ''}`}>
      <h2>Interactive Form</h2>
      <form onSubmit={handleSubmit} className="animated-form">
        
        <label htmlFor="name">Name:</label>
        <input
          type="text"
          id="name"
          name="name"
          onChange={handleChanges}
          value={selectedUser.name}
          placeholder='change name'
          required
        />

        <label htmlFor="email">Email:</label>
        <input
          type="email"
          id="email"
          name="email"
          onChange={handleChanges}
          value={selectedUser.email}
          placeholder="change email"
          required
        />

        <label htmlFor="phone">Phone:</label>
        <input
          type="tel"
          id="phone"
          name="phone"
          onChange={handleChanges}
          value={selectedUser.phone}
          placeholder="change phone"
          required
        />

       <label htmlFor="phone">address:</label>
        <input
          type="text"
          id="address"
          name="address"
          onChange={handleChanges}
          value={selectedUser.address}
          placeholder="change address"
          required
        />

        <button type="submit">Update</button>
      </form>
    </div>





    <div style={{}} className={`form2-container ${submitted ? 'submitted' : ''}`}>
      <h2>Change password</h2>
      <form onSubmit={handleSubmit1} className="animated-form">
        
        <label htmlFor="name">current password:</label>
        <input
          type="text"
          id="name"
          name="currentPassword"
          value={formData1.currentPassword}
          onChange={handleChange1}
          placeholder="Enter your name"
          required
        />

        <label htmlFor="email">new password:</label>
        <input
          type="text"
          id="email"
          name="newPassword"
          value={formData1.newPassword}
          onChange={handleChange1}
          placeholder="new password"
          required
        />

        <label htmlFor="phone">confirm password:</label>
        <input
          type="password"
          id="phone"
          name="confirmPassword"
          value={formData1.confirmPassword}
          onChange={handleChange1}
          placeholder="confirm password"
          required
        />
    {error && <p className="error-message">{error}</p>}
        <button onClick={handleSubmit1} type="submit">Update</button>
      </form>
    </div>
    </div>
  );
};

export default Profile;
